import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
/** IMEINumberPipe */
@Pipe({
    standalone: true,
    name: 'imeiNumberPipe',
})
export class IMEINumberPipe implements PipeTransform {
    /**
     *
     * @param ts
     */
    public constructor (private ts: TranslateService) { }
/** transform */
  public transform (imei: string, args?: any): string {

    const imieLabel: string = this.ts.instant('common.imei.std-headline');

    if (imei) {

      return imieLabel + ' ' + imei;
    }

    return '';
  }
}
